// extracted by mini-css-extract-plugin
export default {"step-card":"StepCard_step-card__jovEq","header":"StepCard_header__e50K7","title":"StepCard_title__II+78","num":"StepCard_num__2UsO+","description":"StepCard_description__WrM6z"};